import http from 'conversations-http/clients/http';
import invariant from '../../lib/invariant';
const getConnectedAccounts = ({
  inboxId
}) => {
  // @ts-expect-error ts-migrate(2554) FIXME: Expected 8 arguments, but got 2.
  invariant(typeof inboxId === 'number' || !isNaN(parseInt(inboxId, 10)), `InboxId must be a Number, got ${inboxId}`);
  return http.get(`/conversations-email/v1/connected-accounts/inbox/${inboxId}`);
};
export { getConnectedAccounts as default, getConnectedAccounts };